import React, { useState } from 'react';
import { toast } from 'sonner';
import { Heart, ChevronDown } from 'lucide-react';
import { api } from '../../utils/api';

/* ─── Recent Tips (collapsible list in the Tip Jar section) ─── */
export const RecentTipsList = () => {
  const [tips, setTips] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const load = async () => {
    setLoading(true);
    try { const res = await api.myRecentTips(); setTips(res.tips || []); }
    catch (e) { toast.error(e.message || 'Failed to load tips'); }
    finally { setLoading(false); }
  };

  return (
    <div className="mt-4" data-testid="recent-tips-section">
      <button
        type="button"
        onClick={() => { setOpen(!open); if (!open && tips === null) load(); }}
        className="w-full flex items-center justify-between p-3 rounded-lg border border-border bg-background/60 hover:bg-muted/40 transition-colors"
        data-testid="recent-tips-toggle">
        <div className="flex items-center gap-2">
          <Heart className="w-4 h-4 text-pink-500" />
          <span className="text-sm font-medium">Recent tips</span>
          {tips && <span className="text-xs text-muted-foreground">({tips.length})</span>}
        </div>
        <ChevronDown className={`w-4 h-4 text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="mt-2 space-y-1 max-h-72 overflow-y-auto">
          {loading && <p className="text-xs text-muted-foreground p-3">Loading…</p>}
          {!loading && tips && tips.length === 0 && (
            <p className="text-xs text-muted-foreground p-3 text-center">No tips yet. They'll appear here automatically once PayPal confirms each payment.</p>
          )}
          {!loading && tips && tips.map((t) => {
            const SYMBOL = { EUR: '€', USD: '$', GBP: '£', CAD: 'CA$', AUD: 'A$', JPY: '¥', CHF: 'CHF ', NZD: 'NZ$' };
            const s = SYMBOL[t.currency] || `${t.currency} `;
            const ok = t.credited && t.payment_status === 'Completed';
            return (
              <div key={t.txn_id} className="flex items-center justify-between gap-3 p-3 rounded-lg bg-background border border-border" data-testid={`tip-row-${t.txn_id}`}>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{t.payer_name || t.payer_email || 'Anonymous'}</p>
                  <p className="text-[10px] text-muted-foreground">{new Date(t.received_at).toLocaleString()}</p>
                </div>
                <div className="text-right">
                  <p className={`text-sm font-bold tabular-nums ${ok ? 'text-pink-600' : 'text-muted-foreground'}`}>{s}{Number(t.amount).toFixed(2).replace(/\.00$/, '')}</p>
                  {!ok && <span className="text-[10px] text-amber-600">{t.payment_status}</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
